// extracted by mini-css-extract-plugin
module.exports = {"diversityExamplesContainer":"Instructions_diversityExamplesContainer__1zDgB","diversityExample":"Instructions_diversityExample__3Gyi-"};